import { SceneElement } from "../gameData";
import { runAction } from "./runAction";
import { evaluateExpression } from "./evaluateExpression";

export function createSceneElement(sceneElement: SceneElement): HTMLElement {
    let tag: string;
    let editElFn: ((el: HTMLElement) => void) | undefined = undefined;
    let shouldApplyTriggers = false;

    switch (sceneElement.type) {
        case "button": {
            tag = "button";
            editElFn = (el) => {
                el.innerText = sceneElement.text;
                el.classList.add("btn");
                if (sceneElement.disabled) {
                    (el as HTMLButtonElement).disabled = !!evaluateExpression(
                        sceneElement.disabled,
                    );
                    el.classList.add("btn--disabled");
                }
            };
            break;
        }
        case "text":
        case "caption": {
            tag = "div";
            editElFn = (el) => {
                el.innerText = sceneElement.text;
            };
            break;
        }
        case "singleChoice": {
            tag = "div";
            editElFn = (el) => {
                const questionEl = document.createElement("div");
                questionEl.innerText = sceneElement.question;
                questionEl.classList.add("element--singleChoice__question");
                el.appendChild(questionEl);

                const answersEl = document.createElement("div");
                answersEl.classList.add("element--singleChoice__answers");
                el.appendChild(answersEl);

                for (const answer of sceneElement.answers) {
                    const answerEl = document.createElement("button");
                    answerEl.innerText = answer.text;
                    answerEl.classList.add(
                        "btn",
                        "element--singleChoice__answers__answer",
                    );
                    answerEl.setAttribute(
                        "data-singleChoiceAnswerId",
                        answer.id,
                    );

                    if (answer.disabled) {
                        answerEl.disabled = !!evaluateExpression(
                            answer.disabled,
                        );
                    }

                    if (answerEl.disabled) {
                        answerEl.classList.add("btn--disabled");
                    } else {
                        answerEl.onclick = () => runAction(answer.action);
                    }

                    answersEl.appendChild(answerEl);
                }
            };
            break;
        }
        case "clickArea": {
            tag = "div";
            shouldApplyTriggers = false;
            editElFn = (el) => {
                const clickEl = document.createElement("div");
                clickEl.classList.add("element--clickArea__click");

                el.style.justifyContent = (() => {
                    switch (sceneElement.align[0]) {
                        case "center": {
                            return "center";
                        }
                        case "left": {
                            return "flex-start";
                        }
                        case "right": {
                            return "flex-end";
                        }
                    }
                })();
                el.style.alignItems = (() => {
                    switch (sceneElement.align[1]) {
                        case "center": {
                            return "center";
                        }
                        case "top": {
                            return "flex-start";
                        }
                        case "bottom": {
                            return "flex-end";
                        }
                    }
                })();

                clickEl.style.width = `${sceneElement.size[0]}${
                    typeof sceneElement.size[0] === "number" ? "px" : ""
                }`;
                clickEl.style.height = `${sceneElement.size[1]}${
                    typeof sceneElement.size[1] === "number" ? "px" : ""
                }`;
                clickEl.style.marginLeft = `${sceneElement.offset[0]}${
                    typeof sceneElement.offset[0] === "number" ? "px" : ""
                }`;
                clickEl.style.marginTop = `${sceneElement.offset[1]}${
                    typeof sceneElement.offset[1] === "number" ? "px" : ""
                }`;

                addTriggersToElement(sceneElement, clickEl);

                el.appendChild(clickEl);
            };
            break;
        }
    }

    const el = document.createElement(tag);

    if (sceneElement.style) {
        Object.assign(el.style, sceneElement.style);
    }

    el.classList.add(
        "element",
        `element--${sceneElement.type}`,
        "--anim-fade-in",
    );
    el.setAttribute("data-id", sceneElement.id);

    if (shouldApplyTriggers) {
        addTriggersToElement(sceneElement, el);
    }

    if (editElFn) {
        editElFn(el);
    }

    return el;
}

function addTriggersToElement(sceneElement: SceneElement, el: HTMLElement) {
    if (!sceneElement.triggers) {
        return;
    }

    for (const trigger of Object.values(sceneElement.triggers)) {
        switch (trigger.type) {
            case "onClick": {
                el.onclick = () => runAction(trigger.action);
                break;
            }
        }
    }
}
